import { useAppShellStore } from '@/stores/useAppShellStore';

export function projectDashboardTabKey(projectId: number | string): string {
  return `ProjectDashboard:${projectId}`;
}

export function formatProjectTabLabel(
  name?: string | null,
  semanticVersion?: string | null,
): string {
  const n = (name ?? '').trim();
  if (!n) return '';
  const ver = (semanticVersion ?? '').trim();
  return ver ? `${n} · ${ver}` : n;
}

/** 项目名加载后回写顶栏页签标题（按 projectId 区分，避免全部显示「项目详情」） */
export function updateProjectDashboardTabLabel(
  projectId: number | string,
  name?: string | null,
  semanticVersion?: string | null,
) {
  const label = formatProjectTabLabel(name, semanticVersion);
  if (!label) return;
  useAppShellStore().updatePageTab(projectDashboardTabKey(projectId), { label });
}
